import cn from "classnames";
import { SpriteIcon } from "components/UI/SpriteIcon";
import SliderPrevIcon from "public/img/icons/slider-prev.svg";
import SliderNexIcon from "public/img/icons/slider-next.svg";
import s from "./ArticleNavigation.module.scss";
import st from "@/styles/modules/typography.module.scss";
import { Link } from "@/components/shared/Link";

type ArticleNavigationProps = {
  entity: string;
  prevLink?: {
    href: string;
    heading: string;
  } | null;
  nextLink?: {
    href: string;
    heading: string;
  } | null;
};

export const ArticleNavigation = ({ prevLink, nextLink, entity }: ArticleNavigationProps) => (
  <ul className={s.nav}>
    {prevLink && (
      <li className={cn(s.navItem, s.navItemPrev)}>
        <Link href={prevLink.href} className={cn(st.card, s.navLink, s.navLinkPrev)}>
          <span className={s.icon}>
            <SpriteIcon icon={SliderPrevIcon} />
          </span>

          <span className={s.text}>{prevLink.heading}</span>
        </Link>
      </li>
    )}

    {nextLink && (
      <li className={cn(s.navItem, s.navItemNext)}>
        <Link href={nextLink.href} className={cn(st.card, s.navLink, s.navLinkNext)}>
          <span className={s.text}>{nextLink.heading}</span>
          <span className={s.icon}>
            <SpriteIcon icon={SliderNexIcon} />
          </span>
        </Link>
      </li>
    )}
  </ul>
);
